import {
  AfterViewInit,
  Component,
  ElementRef,
  Input,
  OnChanges,
  SimpleChanges,
  ViewChild
} from '@angular/core';
import { RouterLink } from '@angular/router';

@Component({
  selector: 'app-bloghero',
  standalone: true,
  imports: [RouterLink],
  templateUrl: './bloghero.component.html',
  styleUrl: './bloghero.component.css'
})
export class BlogheroComponent implements OnChanges, AfterViewInit {
  @ViewChild('heroVideo') private heroVideoRef?: ElementRef<HTMLVideoElement>;

  @Input() pageTitle = 'Customer Feedback';
  @Input() title = 'What clients say about working with United Team Building';
  @Input() quote = 'What clients say about working with United Team Building';
  @Input() text =
    'We offer a comprehensive range of services designed to meet the unique needs of your business. From strategy development to risk management, our expert team is dedicated to driving your success.';
  @Input() author = '';
  @Input() role = '';
  @Input() date = '';
  @Input() imageSrc = 'assets/customer-feedback-hero.svg';
  @Input() imageAlt = 'Illustration representing client feedback';
  @Input() videoSrc = '';
  @Input() posterCaption = '';

  @Input() readMoreLabel = 'Read More';
  @Input() readMoreLink = '/services';

  @Input() contactLabel = 'Contact Us';
  @Input() contactLink = '/contact-us';

  @Input() qaLabel = 'Q & A';
  @Input() qaLink = '/q-and-a';

  ngAfterViewInit(): void {
    this.loadHeroVideo();
  }

  ngOnChanges(changes: SimpleChanges): void {
    if (changes['videoSrc']) {
      this.loadHeroVideo();
    }
  }

  private loadHeroVideo(): void {
    if (!this.videoSrc || !this.heroVideoRef?.nativeElement) {
      return;
    }

    const video = this.heroVideoRef.nativeElement;
    video.load();
    void video.play().catch(() => undefined);
  }
}
